module.exports = __webpack_public_path__ + "img/W7026-trad.8484fbc1.jpg";